import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ImageOff } from "lucide-react";

// API images require the auth header, so <img src> can't hit the API directly —
// fetch as a blob through axios and render an object URL.
export const AuthImage = ({ path, alt = "Photo", className = "", testId = "auth-image", onClick }) => {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl = "";
    let cancelled = false;
    setUrl("");
    setFailed(false);
    api
      .get(path, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (failed)
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`}>
        <ImageOff className="h-5 w-5" />
      </div>
    );
  if (!url) return <div className={`animate-pulse bg-muted ${className}`} />;
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      className={`object-cover ${className}`}
      data-testid={testId}
      onClick={onClick}
    />
  );
};
